import React, { createContext, useState, useEffect, useContext } from 'react';
import { useCoreStateContext } from 'spark-core-dx/contexts';
import { ItemServiceFactory } from 'spark-core-dx/services';
import { useGenericManager } from 'spark-core-dx/hooks';

export const CoreAuthDomainContext = createContext();

export function CoreAuthDomainContextProvider({ children }) {

    const coreState = useCoreStateContext();
    const coreAuthMgr = useGenericManager(ItemServiceFactory.ItemServiceEnum.CoreAuth);

    //const currentRoute = useCoreRoute();
    //const [loadingState, setLoadingState] = useState(true)
    //const location = useLocation();
    
    useEffect(() => {
        return () => {
            coreState.clear()
        }
    }, [])

    return (
        <CoreAuthDomainContext.Provider value={coreAuthMgr}>
            {children}
        </CoreAuthDomainContext.Provider>

    );
}
export const useCoreAuthDomainContext = () => useContext(CoreAuthDomainContext);